'use client';

import {useEffect, useState} from 'react';

// True once a frame has been painted after mount: the first requestAnimationFrame runs before
// the next paint, the second after it. Lets below-the-fold media start downloading only after
// the page's first paint, so it never competes with the LCP image.
export function useAfterFirstPaint(enabled = true): boolean {
  const [painted, setPainted] = useState(!enabled);

  useEffect(() => {
    if (!enabled) {
      return;
    }
    let second = 0;
    const first = requestAnimationFrame(() => {
      second = requestAnimationFrame(() => {
        setPainted(true);
      });
    });
    return () => {
      cancelAnimationFrame(first);
      cancelAnimationFrame(second);
    };
  }, [enabled]);

  return painted;
}
